// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1_WKM","consentsList":"PatientConsents_consentsList__3DjpE","consentsListEmpty":"PatientConsents_consentsListEmpty__l9z-7"};